<template>
  <div>
    <v-container v-if="survey != 'Encuesta ya fué respondida por el usuario'" style="background-color: transparent">
      <v-layout justify-center>
        <v-flex md8 class="text-sm-left text-xs-left">
          <v-form @submit.prevent="done()">
            <v-card>
              <v-flex>
                <div class="image">
                  <v-img :src="survey.image" aspect-ratio="3.2" contain alt></v-img>
                  <div>
                    <h2 class="text-md-center">
                      <span>{{ survey.name}}</span>
                    </h2>
                    <v-flex class="headline text-md-center" pt-4>{{ survey.description }}</v-flex>
                  </div>
                </div>
              </v-flex>
            </v-card>
            <br />
            <v-layout row wrap v-if="current_user">
              <v-flex xs12 sm6 md4 pa-1>
                Usuario:
                <v-text-field
                  :label="current_user.name + ' ' + current_user.last_name"
                  disabled
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                Anexo:
                <v-text-field :label="current_user.annexed" disabled outline></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pa-1>
                Empresa:
                <v-text-field :label="current_user.company" disabled outline></v-text-field>
              </v-flex>
            </v-layout>
            <v-card>
              <v-flex pa-4 v-if="survey.questions">
                <div v-for="(question, index) in survey.questions" :key="index">
                  <h2
                    class="font-weight-light"
                  >Pregunta {{ index + 1 }}: {{ question.title }} {{!question.optional ? "*" : ""}}</h2>
                  <h4 class="font-weight-light font-itali">{{ question.description }}</h4>
                  <v-layout justify-left>
                    <v-flex xs12 sm6 md8 v-if="question.question_type == 'Texto'">
                      <input-text :question="question" @get_answer="sendAnswers" />
                    </v-flex>
                    <v-flex xs12 sm6 md8 v-if="question.question_type == 'Número'">
                      <input-number :question="question" @get_answer="sendAnswers" />
                    </v-flex>
                    <v-flex xs10 sm6 md4 v-if="question.question_type == 'Verdadero o Falso'">
                      <input-radio-button :question="question" :options="question.options" @get_answer="sendAnswers" :row="true"/>
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-if="question.question_type == 'Escala lineal'">
                      <input-radio-button :question="question" @get_answer="sendAnswers" :row="true" :lineal="true"/>
                    </v-flex>
                    <v-flex xs12 sm6 md5 pb-4 v-if="question.question_type == 'Múltiple'">
                      <input-checkbox :question="question" :options="question.options" @get_answer="sendAnswersMultiple" />
                    </v-flex>
                    <v-flex xs12 sm6 md5 pb-4 v-if="question.question_type == 'Cargas Múltiple'">
                      <input-checkbox :question="question" :options="current_user.family_members" @get_answer="sendAnswersMultiple" />
                    </v-flex>
                    <v-flex xs12 sm6 md5 pb-4 v-if="question.question_type == 'Hijos'">
                      <input-checkbox :question="question" :options="getSons()" @get_answer="sendAnswersMultiple" />
                    </v-flex>
                    <v-flex xs12 sm6 md5 v-if="question.question_type == 'Simple'">
                      <input-radio-button :question="question" :options="question.options" @get_answer="sendAnswers"/>
                    </v-flex>
                    <v-flex xs12 sm6 md5 v-if="question.question_type == 'Cargas Simple'">
                      <input-radio-button :question="question" :options="current_user.family_members" @get_answer="sendAnswers"/>
                    </v-flex>
                    <v-flex xs12 sm6 md5 v-if="question.question_type == 'Selección'">
                      <input-select :question="question" @get_answer="sendAnswers"/>
                    </v-flex>
                  </v-layout>
                </div>
                <v-flex text-xs-right>
                  <v-btn
                    v-if="current_user.role == 'admin'"
                    flat
                    color="primary"
                    :href="survey.url"
                    target="_blank"
                  >Editar</v-btn>
                  <v-btn flat color="primary" @click="goToSurveysList">Volver</v-btn>
                  <v-btn large round type="submit" letiant="primary" color="success">Enviar</v-btn>
                </v-flex>
              </v-flex>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="text-md-center" v-else>
      <h1>Esta encuesta ya fue respondida</h1>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import config from "@/config";
import { validationMixin } from "vuelidate";
import axios from "axios";
import InputNumber from "../Form/InputNumber";
import InputText from "../Form/InputText";
import InputRadioButton from "../Form/InputRadioButton";
import InputCheckbox from "../Form/InputCheckBox";
import InputSelect from "../Form/InputSelect";

let answered = [];
export default {
  mixins: [validationMixin],
  components: {
    InputNumber,
    InputText,
    InputCheckbox,
    InputRadioButton,
    InputSelect
  },
  data() {
    return {
      text: "",
      question: "",
      bool: "",
      selectOptions: "",
      selectedTitle: "",
      answers: []
    };
  },
  props: {
    survey: {
      type: Object,
      required: true
    }
  },
  created() {
    // Redirecciona a Home en caso que la encuesta se encuentre en estado "Borrador"
    if (this.survey.status == "Borrador" && !this.current_user.role.includes('admin')) {
      this.$router.push({ name: "home" });
    }
  },
  mounted() {
    // Esto se debe correr para evitar mantener los mismos datos al cambiarse entre encuestas
    answered = [];
  },
  methods: {
    ...mapActions("surveys", ["addAnswer"]),
    selectTitle(e) {
      this.selectedTitle = e;
    },
    goToSurveysList() {
      this.$router.push({
        name: "surveys"
      });
    },
    getOptionsSelect(options) {
      let filtered = [];
      options.forEach(function(element) {
        filtered.push(element.title);
      });
      return filtered;
    },
    checkData() {
      let uniq = [...new Set(answered)];
      if (
        uniq.length !==
        this.survey.questions.filter(question => !question.optional).length
      ) {
        Swal.fire({
          title: "¡Importante!",
          text: "Debes contestar todas las preguntas obligatorias. (*)",
          type: "warning",
          confirmButtonText: "Aceptar"
        });
        return false;
      } else return true;
    },
    optionalAnswered2(data) {
      if (data.question.optional == false && data.option != "") {
        answered.push(data.question.id);
        answered = [...new Set(answered)];
      } else if (data.question.optional == false && data.option == ""){
        let index = answered.indexOf(data.question.id);
        answered.splice(index, 1);
      }
    },
    optionalAnswered(question) {
      if (question.optional == false) {
        answered.push(question.id);
        answered = [...new Set(answered)];
      }
    },
    sendAnswers(data) {
      this.optionalAnswered2(data);
      // this.optionalAnswered(data.question);
      let answer = this.answers.find(a => a.questionId == data.question.id);
      if (answer) {
        answer.questionId = data.question.id;
        answer.option = data.option;
      } else {
        this.answers.push({
          questionId: data.question.id,
          option: data.option
        });
      }
    },
    sendAnswersMultiple(data) {
      // this.optionalAnswered(data.question);
      let answer = this.answers.find( a => a.questionId == data.question.id && a.option == data.option );

      if (answer) {
        let index = this.answers.indexOf(answer);
        this.answers.splice(index, 1);
        // Quita el id del arreglo 'answered' cuando una pregunta obligatoria está sin contestar
        if (data.question.optional == false) {        
          let index_answered = answered.indexOf(data.question.id);
          answered.splice(index_answered, 1);
          answered = [...new Set(answered)];
        }
      } else {
        this.answers.push({ questionId: data.question.id, option: data.option });
        // Agrega el ID de la pregunta al arreglo 'answered' cuando una pregunta obligatoria está respondida
        if (data.question.optional == false){
          answered.push(data.question.id);
          answered = [...new Set(answered)];
        }
      }
    },
    done() {
      if (this.checkData())
        try {
          this.addAnswer(this.answers);
          Swal.fire({
            title: "Encuesta respondida con éxito",
            timer: 2000,
            type: "success"
          });
          this.$router.push({
            name: "surveys"
          });
        } catch (err) {
          // console.log(err);
        }
    },
    getSons() {
      return this.current_user.family_members.filter( member => member.relation == 'Hija' || member.relation == 'Hijo');
    }
  },
  computed: {
    ...mapState("user", ["current_user"])
  }
};
</script>

<style scoped>
h2 {
  padding-bottom: 12px;
}
h2 span {
  color: white;
  font: bold 24px/45px Helvetica, Sans-Serif;
  letter-spacing: -1px;
  background: rgb(0, 0, 0); /* fallback color */
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
}
</style>
